import { connect } from 'react-redux';

import WelcomeScreen from './WelcomeScreen';
import { setOrderStateForUuid } from '../../modules/SignUp/Order/actions';
import { setGodfatherExternalId } from '../../modules/SignUp/Bonus';
import { resetCustomerData } from '../../modules/Authentication';
import config from '../../config';

type StateProps = {
  areCheatCodesEnabled: Boolean,
  canAccessStyleGuide: Boolean,
};

type DispatchProps = {
  resetCustomerData: Function,
  setGodfatherExternalId: Function,
  setOrderStateForUuid: Function,
};

const mapStateToProps = (): StateProps => ({
  areCheatCodesEnabled: config.areCheatCodesEnabled,
  canAccessStyleGuide: config.canAccessStyleGuide,
});

const mapDispatchToProps: DispatchProps = {
  resetCustomerData,
  setGodfatherExternalId,
  setOrderStateForUuid,
};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeScreen);
